import GenericDB from './generic-db';

export default class SessionNoteTemplatesDB extends GenericDB {
  constructor() {
    super('sessionNoteTemplates');
  }

  /**
   * Tries to load a session note template by id
   *
   * @param {string} templateId
   * @returns {Promise<Object|null>} - note template object or null
   */
  async readNoteTemplateIfExists(templateId) {
    try {
      const docRef = await this.getDocSnapshot(templateId);

      return docRef.exists()
        ? { id: templateId, ...docRef.data() }
        : null;
    } catch (err) {
      throw new Error(err);
    }
  } // readNoteTemplateIfExists()
}
